(function () {
  'use strict';

  function postJSON(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body),
      credentials: 'same-origin',
    }).then(function (r) { return r.json(); });
  }

  function getCart() {
    return fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); });
  }

  function buildM2Map() {
    var map = {};
    var inputs = document.querySelectorAll('input[data-variantid][data-m2perpallet]');
    for (var i = 0; i < inputs.length; i++) {
      var el = inputs[i];
      var variantId = el.dataset.variantid;
      var raw = (el.dataset.m2perpallet || '').replace(',', '.');
      var parsed = parseFloat(raw);
      if (variantId && !isNaN(parsed) && parsed > 0) {
        map[variantId] = parsed;
      }
    }
    return map;
  }

  function isBroken(item, m2PerPallet) {
    if (!m2PerPallet || m2PerPallet <= 0) return false;
    var props = item.properties || {};
    var totaal = props['Totaal m²'];
    if (!totaal) return true;
    var parsed = parseFloat(String(totaal).replace(',', '.'));
    return isNaN(parsed) || parsed <= 0;
  }

  async function repairCart(m2Map) {
    var cart = await getCart();
    var repaired = 0;
    for (var i = 0; i < cart.items.length; i++) {
      var item = cart.items[i];
      var m2PerPallet = m2Map[item.variant_id];
      if (!isBroken(item, m2PerPallet)) continue;

      var qty = item.quantity;
      var totalM2 = (m2PerPallet * qty).toFixed(2);
      var props = Object.assign({}, item.properties || {}, {
        'Totaal m²': totalM2,
        '_initial_totalm2': totalM2,
        '_initial_quantityy': String(qty),
      });
      await postJSON('/cart/change.js', { line: i + 1, quantity: qty, properties: props });
      repaired++;
    }
    return repaired;
  }

  function isCheckoutSubmit(e) {
    var s = e.submitter;
    if (!s) return false;
    return s.name === 'checkout' || s.id === 'CartDrawer-Checkout';
  }

  function ensureCheckoutInput(form) {
    var existing = form.querySelector('input[type="hidden"][name="checkout"]');
    if (existing) return;
    var input = document.createElement('input');
    input.type = 'hidden';
    input.name = 'checkout';
    input.value = '';
    form.appendChild(input);
  }

  function attachGuard(form) {
    if (!form || form.__m2GuardAttached) return;
    form.__m2GuardAttached = true;

    form.addEventListener('submit', async function (e) {
      if (!isCheckoutSubmit(e)) return;
      e.preventDefault();

      var btn = e.submitter;
      if (btn) {
        btn.disabled = true;
        btn.classList.add('loading');
      }

      try {
        var m2Map = buildM2Map();
        if (Object.keys(m2Map).length > 0) {
          await repairCart(m2Map);
        }
      } catch (err) {
        console.error('[m2-guard] repair failed:', err);
      }

      ensureCheckoutInput(form);
      form.submit();
    });
  }

  function init() {
    attachGuard(document.getElementById('cart'));
    attachGuard(document.getElementById('CartDrawer-Form'));
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-attach when the cart drawer re-renders its form after a cart update.
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[name="checkout"], #CartDrawer-Checkout');
    if (!btn) return;
    var formId = btn.getAttribute('form');
    if (!formId && btn.closest) {
      var parentForm = btn.closest('form');
      if (parentForm) formId = parentForm.id;
    }
    if (formId) attachGuard(document.getElementById(formId));
  }, true);
})();
